import type { RouteRecordRaw } from 'vue-router';
import { SupportFaqRoutes } from './modules/Faq';
import { SupportGuidesRoutes } from './modules/Guides';
import { SupportHomeRoutes } from './modules/Home';
import { SupportHowToRoutes } from './modules/HowTo';
import { SupportTipsRoutes } from './modules/Tips';
import { SupportWhatsNewRoutes } from './modules/WhatsNew';

export default <RouteRecordRaw[]>[
  {
    path: '/support',
    component: () => import('../../../layouts/TheMainLayout/TheMainLayout.vue'),
    redirect: () => '/support/home',
    children: [
      ...SupportFaqRoutes,
      ...SupportGuidesRoutes,
      ...SupportHomeRoutes,
      ...SupportHowToRoutes,
      ...SupportTipsRoutes,
      ...SupportWhatsNewRoutes,
    ],
    meta: {
      isSupport: true,
    },
  },
];
